import React, { useMemo, type FC } from "react";

import cn from "classnames";

import { getChildrenRecord } from "../../../utils/react";

import type { ButtonsCircleViewProps } from "./types";

import classes from "./ButtonsCircleView.styl";

export const BUTTONS_CIRCLE_VIEW_DISPLAY_NAME = "ButtonsCircleView";

const BUTTONS_CIRCLE_VIEW_TEST_ID = "buttons-circle-view-test-id";

/**
 * Контейнер, который систематизирует круглые кнопки в горизонтальном контейнере.
 *
 * <a href="https://www.figma.com/design/LYZAXE33pUg2cSL5mmUHYq/%F0%9F%8D%91-Buttons-%26-Tabs-%26-Chips?m=auto&node-id=2-266481" target="_blank">Спека</a>
 * @constructor
 */

const ButtonsCircleView: FC<ButtonsCircleViewProps> = (props) => {
    const { "data-tsid": tsid, customVarsStyles, children } = props;

    const content = useMemo(
        () =>
            getChildrenRecord(
                children,
                BUTTONS_CIRCLE_VIEW_DISPLAY_NAME,
                {
                    ButtonCircle: {
                        required: true,
                    },
                    Unknown: {
                        skipElement: true,
                    },
                },
                { isArrayResult: true },
            ),
        [children],
    );

    return (
        <div
            className={classes["container"]}
            data-tsid={tsid || BUTTONS_CIRCLE_VIEW_TEST_ID}
            data-uikit={BUTTONS_CIRCLE_VIEW_DISPLAY_NAME}
        >
            <ul className={cn(classes["wrapper"], customVarsStyles)}>
                {content.map((el, index) => {
                    return <li key={index}>{el}</li>;
                })}
            </ul>
        </div>
    );
};

ButtonsCircleView.displayName = BUTTONS_CIRCLE_VIEW_DISPLAY_NAME;

export default ButtonsCircleView;
